import React, { useRef, useState, useEffect, useCallback } from 'react';
import Dropzone from 'react-dropzone';

// def necessary_papers_preview(application, column_name)で返される型
interface UploadedFile {
  file_name: string;
  url: string;
  preview: string;
}

interface Props {
  inputId: string;
  inputName: string;
  uploadedFiles: UploadedFile[];
}

export default function FileUploadView({
  inputId,
  inputName,
  uploadedFiles,
}: Props) {
  const inputFileRef = useRef<HTMLInputElement | null>(null);
  const [uploadFiles, setUploadFiles] = useState<File[]>([]);

  const convertUrlToFile = useCallback((file: UploadedFile): Promise<File> => {
    return new Promise((resolve, reject) => {
      fetch(file.url)
        .then(response => response.blob())
        .then(blob => new File([blob], file.file_name))
        .then(file => {
          // TODO: fix Fileを拡張してしまっている
          // @ts-expect-error 型 'File' に存在しない preview を参照するため
          file.preview = URL.createObjectURL(file);
          resolve(file);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  }, []);

  useEffect(() => {
    (async () => {
      const files = await Promise.all(
        uploadedFiles.map(async file => await convertUrlToFile(file)),
      );
      const dt = new DataTransfer();
      files.forEach(file => dt.items.add(file));
      if (inputFileRef.current) {
        inputFileRef.current.files = dt.files;
        $(inputFileRef.current).trigger('change');
      }
      setUploadFiles(files);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- react-hooks ルール有効化に伴う既存実装の暫定許容（別途対応）
  }, [uploadedFiles]);

  const onUploadFile = (files: File[]) => {
    if (uploadFiles.length + files.length > 5) {
      // @ts-expect-error 名前 'notify' が型定義に存在しないため
      notify(
        '',
        '添付ファイルは最大5つまでです。',
        'top',
        'center',
        '',
        'danger',
        '',
        '',
      );
      return;
    }
    const newFiles = [...uploadFiles, ...files];
    const dt = new DataTransfer();
    newFiles.forEach(file => dt.items.add(file));
    if (inputFileRef.current) {
      inputFileRef.current.files = dt.files;
      $(inputFileRef.current).trigger('change');
    }
    setUploadFiles(newFiles);
  };

  const onClickRemove = (listIndex: number) => {
    const removedFiles = uploadFiles.filter((_, index) => index !== listIndex);
    const dt = new DataTransfer();
    removedFiles.forEach(file => dt.items.add(file));
    if (inputFileRef.current) {
      inputFileRef.current.files = dt.files;
      $(inputFileRef.current).trigger('change');
    }
    setUploadFiles(removedFiles);
  };

  return (
    <div className="file-upload-area">
      <Dropzone
        onDrop={onUploadFile}
        accept=".pdf,.jpg,.jpeg,.png,.gif"
        className="item drop-zone"
      >
        <div className="drop-zone__content">
          <input
            hidden
            ref={inputFileRef}
            type="file"
            id={inputId}
            name={inputName}
            accept=".pdf,.jpg,.jpeg,.png,.gif"
            multiple={true}
          />
          <i className="fas fa-cloud-upload-alt fa-3x" aria-hidden="true" />
          <p className="mb-0 attention-main">
            ここにファイルをドロップしてください。
          </p>
          <p className="mb-40 attention-main">またはファイルを選択する</p>
          <p className="mb-0 attention-sub text-center">
            pdf、jpg、jpeg、png、gifのみ
            <br className="tb" />
            アップロード可能です。
          </p>
          <p className="mb-0 attention-sub text-center">
            スマートフォンで撮影した写真も
            <br className="tb" />
            アップロード可能です。
          </p>
        </div>
      </Dropzone>

      {uploadFiles.length > 0 && (
        <div className="item uploaded-files">
          <p className="uploaded-files-title">アップロード済ファイル</p>
          <ul className="uploaded-files-list">
            {uploadFiles.map((file, index) => {
              return (
                <li key={index}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center overflow-hidden">
                      {file.type !== 'application/pdf' && (
                        // TODO: fix Fileを拡張してしまっている
                        // @ts-expect-error 型 'File' に存在しない preview を参照するため
                        <img src={file.preview} />
                      )}
                      <p className="mb-0 filename">{file.name}</p>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="remove"
                        onClick={() => onClickRemove(index)}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
